export enum PlayerEvent {
    START,
    STOP,
    PAUSE,
    RESUME,
    STALL,
    CONTINUE,
    ADVERT_REWIND,
    ADVERT_SKIP,
    SEEK
}
